// base.js
import modal from './components/modal'

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

import { toggleMenu, toggleLink, debouncedCloseMenu } from './components/header';

let mobileBtn, mainMenu, mainMenuItems;

document.addEventListener("DOMContentLoaded", function() {
  const viewport = window.innerWidth;
  const isMobile = viewport < 640;

  mobileBtn = document.getElementById('mainHeader__btn-mobile');
  mainMenu = document.getElementById('mainHeader__menu');
  mainMenuItems = document.querySelectorAll('.mainHeader__item');

  // Main Header actions with debounce for mobile button click
  mobileBtn.addEventListener('click', debounce(() => {
    toggleMenu(mainMenu);
  }, 250));

  // Event delegation for main menu items
  mainMenuItems.forEach(link => {
    link.addEventListener('click', (event) => {
      const target = event.target;
      toggleLink(target);
    });
  })

  // Global click listener for closing the menu
  document.addEventListener('click', (event) => debouncedCloseMenu(event, mainMenu, null));

  // Remove lazy loading for iOS devices due to compatibility issues
  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    const sliderSection = document.getElementById('sliderClients');
    if (sliderSection) {
      const lazyImages = sliderSection.querySelectorAll('img[loading="lazy"]');
      lazyImages.forEach(img => img.removeAttribute('loading'));
    }
  }

  //Add title on complianz links
  const cmplzManageConsent = document.querySelector('a[data-relative_url="#cmplz-manage-consent-container"]')
  const cmplzCookiesOverview = document.querySelector('a[data-relative_url="#cmplz-cookies-overview"]')
  const cmplzTcfWrapper = document.querySelector('a[data-relative_url="#cmplz-tcf-wrapper"]')
  const cmplzReadMore = document.querySelector('a[data-relative_url="#cmplz-tcf-wrapper"]')

  const cmplzLinks = [cmplzManageConsent,cmplzCookiesOverview,cmplzTcfWrapper,cmplzReadMore].filter(link => link !== null)

  cmplzLinks.forEach((link) => {
    const linkText = link.innerHTML
    link.title = linkText
  })
});

export { mobileBtn, mainMenu, mainMenuItems };
